import {useTranslation} from "react-i18next";
import clsx from "clsx";
import {useFormikContext} from "formik";

import DeleteIcon from "../../../images/icons/delete.png";
import ImageButton from "../../../utilities/Buttons/ImageBtn";
import {checkEmptyAndNullFields} from "../../../utilities/checkEmptyFields";
import {dateFormat, dateTimeFormat} from "../../../utilities/dateFormat";
import {UI_PERMISSION_TYPE} from "../../adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";

import {useFiltersContext} from "./useSessionFiltersContext";

const ChosenFiltersLine = ({filterNames, onFilterDelete, enableTime}) => {
  const {t} = useTranslation();
  const {filters, setFilters, clearSessionFilters} = useFiltersContext();
  const {setValues, setFieldValue} = useFormikContext();

  const makeFilterTitle = filter => {
    const optionsValue =
      filterNames?.[filter]?.type === "date"
        ? enableTime
          ? dateTimeFormat(filters[filter])
          : dateFormat(filters[filter])
        : filterNames[filter]?.value;

    return filterNames[filter]?.value && filters[filter] ? `${t(filterNames[filter].label)}: ${optionsValue}` : "";
  };

  function onDeleteSavedFilterBtnClick(filter) {
    //!фикс для корректного актив/деактив значка
    const aliasMap = {
      country: ["country", "countryId"],
      countryId: ["country", "countryId"],
    };
    const keysToDrop = new Set(aliasMap[filter] || [filter]);
    const filteredKeys = Object.keys(filters).filter(key => !keysToDrop.has(key));
    const newFilters = filteredKeys.reduce((result, key) => ({...result, [key]: filters[key]}), {});
    const cleaned = checkEmptyAndNullFields(newFilters);
    try {
      (aliasMap[filter] || [filter]).forEach(k => setFieldValue(k, null, false));
    } catch (e) {
      console.log(e);
    }
    if (Object.keys(cleaned).length === 0) {
      setFilters(null);
      setValues({});
      try {
        clearSessionFilters?.();
      } catch (e) {
        console.log(e);
      }
    } else {
      setFilters(cleaned);
      setValues(cleaned);
    }
    onFilterDelete(filter);
  }

  const row = filters
    ? Object?.keys(filters)?.map(filter => {
        if (!filters[filter]) return;

        return (
          <div key={filter} className="row borderMiddle gap5 paddingMiddle">
            <div style={{fontSize: "0.9rem"}}>{makeFilterTitle(filter)}</div>
            <ImageButton
              src={DeleteIcon}
              onClick={() => onDeleteSavedFilterBtnClick(filter)}
              uiPermissionType={UI_PERMISSION_TYPE.READABLE}
            />
          </div>
        );
      })
    : null;

  const isHidden = !filters || (typeof filters === "object" && Object.keys(filters).length === 0);

  return (
    <div
      className={clsx("row jcfs", isHidden && "hiddenEl")}
      style={{
        // border: "1px solid #426ca681",
        padding: "7px 7px 0 7px",
      }}
    >
      {row}
    </div>
  );
};

export default ChosenFiltersLine;
